import { labels } from './labels.js';

export var store = {
  state: {
    keys: [], 
    customerKeys: [],

    labels: [],
    customerLabels: [],

    productId: 0,
    attributes: [],
    attributesGroups: [],
    qty: 1,
    settings: {
      customerId: 0,
      langId: Cookies.get('marketplace-lang')
    },
    status: {
      isLoading: false,
      isAdding: false,
      activeGroup: 0
    }
  },
  getLabels: function () {
    return $.ajax({
      url: '/api/APIStore/GetLabels',
      type: 'GET',
      data: {
        langId: store.state.settings.langId,
        keys: store.state.keys
      }
    })
      .done(function (data) {
        store.state.labels = data;
      })
  },
  getLabel: function (key) {
    var index = _.findIndex(store.state.labels, function (o) {
      return o.Key == key;
    });

    if (index == -1) {
      return "";
    }

    return store.state.labels[index].Value;
  },
  getCustomerLabels: function () {

    var keys = this.state.customerKeys.map(function (o) {
      return encodeURIComponent(o);
    })

    var labelsRequest = {
      langId: store.state.settings.langId,
      keys: keys
    };

    return $.ajax({
      url: '/api/APIStore/GetCustomerLabels',
      type: 'POST',
      contentType: "application/json; charset=utf-8",
      dataType: 'json',
      data: JSON.stringify(labelsRequest)
    })
      .done(function (data) {
        store.state.customerLabels = data.map(function (o) {
          o.Key = decodeURIComponent(o.Key);
          o.Value = decodeURIComponent(o.Value);

          return o;
        });
      })
  },
  getCustomerLabel: function (key) {
    var index = _.findIndex(store.state.customerLabels, function (o) {
      return o.Key == key;
    });

    if (index == -1) {
      return "";
    }

    return store.state.customerLabels[index].Value;
  },
  getProductId: function () {
    var sPageURL = window.location.href;
    var indexOfLastSlash = sPageURL.lastIndexOf("/");

    if (indexOfLastSlash > 0 && sPageURL.length - 1 != indexOfLastSlash) {
      this.state.productId = sPageURL.substring(indexOfLastSlash + 1);
    }
  },
  getAttributes: function () {
    var self = this;
    var productId = self.state.productId;

    return $.ajax({
      url: '/api/APIProductAttributes/GetProductAttributes/' + productId,
      type: 'GET'
    })
      .done(function (data) {
        self.state.attributes = data;
      })
  },
  getAttributesLabels: function () {
    var self = this;

    // Foreach Attribute
    _.forEach(self.state.attributes, function (a) {
      if (a.Label != null && a.Label != undefined) {
        self.state.customerKeys.push(a.Label.trim());
      }

      if (a.Group != null && a.Group != undefined) {
        self.state.customerKeys.push(a.Group.Label);
        self.state.customerKeys.push(a.Group.LabelDescription);
      }

      if (a.LabelDescription != null && a.LabelDescription != undefined) {
        self.state.customerKeys.push(a.LabelDescription.trim());
      }      

      // Foreach Options in the attribute 
      _.forEach(a.Options, function (o) {

        if (o.Label != null && o.Label != undefined) {
          self.state.customerKeys.push(o.Label.trim());
        }
        
      })

    })
  },
  getAttributesGroups: function () {
    var self = this;
    var groups = [];
        
    _.forEach(self.state.attributes, function (o) {
      if (o.Group != null && o.Group != undefined) {

        var index = _.findIndex(groups, function (g) {
          return g.Id == o.Id;
        })

        if (index == -1) {          
          groups.push(o.Group);
        }
      }
    });

    groups = _.uniqBy(groups, function (o) {
      return o.Id;
    });

    groups =_.sortBy(groups, function (o) {
      return o.Sequence;
    });

    self.state.attributesGroups = groups;

    if (self.state.attributesGroups.length > 0) {
      self.toggleActiveGroup(self.state.attributesGroups[0].Id);
    }
    
  },
  getFileExtension: function (fileName) {

    if (fileName === null) {
      return '';
    }
    var index = fileName.lastIndexOf('.');
    var extension = '';
    if (index != -1) {
      extension = fileName.substring(index);
    }

    return extension;
  },
  toggleActiveGroup: function (id) {
    if (this.state.status.activeGroup == id) {
      this.state.status.activeGroup = 0;
    }
    else {
      this.state.status.activeGroup = id;
    }
  },
  setToastrDefaults: function () {    
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-top-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "1000",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    };
  },
  addToCart: function () {
    var self = this;
    self.state.status.isAdding = true;

    var formData = new FormData();

    var filesAttr = _.filter(self.state.attributes, function (o) {
      return o.Type == 4;
    });

    for (var i = 0; i < filesAttr.length; i++) {
      formData.append('file', filesAttr[i].File);      
    }

    var request = {
      ProductId: self.state.productId,
      Qty: self.state.qty,
      ProductAttributes: self.state.attributes
    };

    formData.append('request', JSON.stringify(request));

    return $.ajax({
      url: '/api/APICart/AddCustom',
      type: 'POST',
      data: formData,
      contentType: false,
      processData: false
    })
      .done(function (data) {
        toastr["success"](store.getLabel('_done'));
      })
      .fail(function () {
        // Toastr notification with error
        toastr["error"](store.getLabel('_webservererror'));
      })
      .always(function () {
        self.state.status.isAdding = false;
      })

  },
  init: function () {
    var self = this;

    self.state.status.isLoading = true;

    store.state.keys = labels;
    store.setToastrDefaults();
    store.getProductId();

    $.when(
      self.getAttributes(),
      store.getLabels()
    )
    .then(function () {
      // Get Customer Labels
      self.getAttributesLabels();
      self.getAttributesGroups();

      $.when(
        self.getCustomerLabels()
      ).then(function () {
        self.state.status.isLoading = false;
      })
    })
  }
};